function initProductSaleCountdowns(root) {
  const scope = root || document;
  scope.querySelectorAll('[data-product-sale-countdown]:not([data-countdown-initialized])').forEach((wrapper) => {
    const endDateStr = wrapper.dataset.endDate;
    const endedText = wrapper.dataset.endedText || 'Sale Ended';
    const display = wrapper.querySelector('[data-countdown-display]');

    if (!endDateStr || !display) return;

    wrapper.dataset.countdownInitialized = 'true';

    const endTime = new Date(endDateStr).getTime();
    if (Number.isNaN(endTime)) return;

    const pad = (value) => String(value).padStart(2, '0');

    const render = () => {
      const timeDiff = endTime - Date.now();

      if (timeDiff <= 0) {
        display.textContent = endedText;
        if (wrapper.countdownInterval) {
          clearInterval(wrapper.countdownInterval);
        }
        return;
      }

      const days = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
      const hours = Math.floor((timeDiff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const mins = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60));
      const secs = Math.floor((timeDiff % (1000 * 60)) / 1000);

      display.textContent = `${days}d ${pad(hours)}:${pad(mins)}:${pad(secs)}`;
    };

    render();
    wrapper.countdownInterval = setInterval(render, 1000);
  });
}

document.addEventListener('DOMContentLoaded', () => initProductSaleCountdowns());
document.addEventListener('shopify:section:load', (event) => initProductSaleCountdowns(event.target));
